import React from 'react';
import { TopicSettingsPage } from './TopicSettingsPage';
import { TopicGroupSettingsPage } from './TopicGroupSettingsPage';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import { isTopicEntity } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/utils';

export function TrafficSettingsPage() {
  const entityType = useMainEntityType();

  return isTopicEntity(entityType) ? <TopicSettingsPage /> : <TopicGroupSettingsPage />;
}
